// extracted by mini-css-extract-plugin
export var article = "styles-module--article--IE4Kd";
export var bgColorHover = "styles-module--bgColorHover--ePJVF";
export var bgImage = "styles-module--bgImage--f6iKT";
export var btnLink = "styles-module--btnLink--DbxtO";
export var button = "styles-module--button--6NETi";
export var content = "styles-module--content--NJl8I";
export var description = "styles-module--description--VVA6+";
export var priceContainer = "styles-module--priceContainer--+X+NE";
export var priceCss = "styles-module--priceCss--i0nzj";
export var title = "styles-module--title--tf7oU";